import { useEffect, useState, useContext } from "react"
import { useHistory } from "react-router-dom"
import { GlobalContext } from "context/context/GlobalContext"
import Logger from "classes/Logger"
import { executeShipingGroupAction } from "services/ShippingGroupService"
import { NOTIFY_CANCEL } from "helpers/constHelper"
import { TransactionCodeEnum } from "enums/TransactionCodeEnum"
import { EShippinggroupAction } from "enums/shippinggroupEmun"
import { IOrder } from "interfaces/IOrder"
import { TypeVariation6 } from "types/CommonsTypes"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"
import useUserPermissions from "hooks/UseUserPermissions"

const UseDeliveredRejectOrder = ({
  order,
  shippingGroupId,
}: { order: IOrder | TypeVariation6, shippingGroupId: string } ) => {
  const { notification, errorHander } = useContext(GlobalContext)

  const [canIuseDeliveredReject, setCanIuseDeliveredReject] = useState(false);

  const [loadingDeliveredReject, setLoadingDeliveredReject] = useState(false)

  const history = useHistory()

  const { permission } = useUserPermissions({ resources: [ResourcePermissionsEnum.deliveredReject] });

  useEffect( () => {
    permission[ResourcePermissionsEnum.deliveredReject] && setCanIuseDeliveredReject(true) 
  }, [permission])

  const handleClickDeliveredRejectOrder = async (action: EShippinggroupAction) => {
    try {
        setLoadingDeliveredReject(true)
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action,
        requestBody: {
            "comment": "REPROCESO",
            "custom": {
                "reason": "SINIESTRO"
            }
         },
      })

      setLoadingDeliveredReject(false)

      //picking success TODO:: case error
      if (code === TransactionCodeEnum.ok) {
        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Orden rechazada correctamente",
            title: NOTIFY_CANCEL,
            type: "success",
          },
        })

        setTimeout(() => history.push("/order/confirmation"), 2000)
      }
    } catch (error: any) {
      Logger.error(error)
      setLoadingDeliveredReject(false)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    handleClickDeliveredRejectOrder,
    loadingDeliveredReject,
    canIuseDeliveredReject
  }
}

export default UseDeliveredRejectOrder
